const copyToClipboard = (c) => {
  const button = c.querySelector("[data-copy-wallet]");
  if (!button) return;

  const label = button.parentNode;

  const target = label.querySelector(".wallet");
  const tip = button.querySelector(".copy-title");

  const onClick = () => {
    target.select();
    target.setSelectionRange(0, 99999);

    navigator.clipboard
      ? navigator.clipboard.writeText(target.value)
      : document.execCommand("copy");

    target.blur();

    tip.innerHTML = "Copied!";
    setTimeout(onLeave, 1000);
  };

  const onEnter = () => {
    button.classList.add("active");
  };

  const onLeave = () => {
    button.classList.remove("active");
    tip.innerHTML = "Copy to clipboard";
  };

  button.addEventListener("click", onClick);
  button.addEventListener("mouseenter", onEnter);
  button.addEventListener("mouseleave", onLeave);
};

export default copyToClipboard;
